/* unplugin-vue-components disabled */import script from "./mg-area-select.vue?vue&type=script&setup=true&lang=js"
export * from "./mg-area-select.vue?vue&type=script&setup=true&lang=js"

import "./mg-area-select.vue?vue&type=style&index=0&id=8902a39c&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8902a39c"]])

export default __exports__